import { sortBy } from 'libraries/lodash'
import {
  SET_LEGISLATION_FOLDERS,
  SET_LEGISLATION_FOLDERS_MAP,
  SET_LEGISLATION_ACT_ID_MAP,
  SET_LEGISLATION_ACT,
  SET_LEGISLATION_ACTS,
  SET_LEGISLATION_PATH,
  SET_LEGISLATION_ACT_NODES,
  SET_LEGISLATION_ACT_HOVER_ICON_MAP,
  SET_LEGISLATION_WRAPPER_ADMIN_BUTTON,
  SET_LEGISLATION_WRAPPER_CONTENT_EDITOR,
  SET_LEGISLATION_WRAPPER_EDIT_MODE,
  SET_LEGISLATION_WRAPPER_TITLE_EDITOR
} from './types'
import { AppDispatch } from 'redux/store';
import { LegislationActNode, LegislationFolder, LegislationAct } from 'interfaces/legislation';
import { JSXElementConstructor } from 'react';
import { TitleEditorProps } from 'components/legislation/admin/TitleEditor';
import { AdminButtonProps } from 'components/legislation/admin/AdminButton';

export const setLegislationPath = (path:string) => ({
  type: SET_LEGISLATION_PATH,
  path
})

export const setLegislationAct = (act:string) => {
  return (dispatch: AppDispatch, _:any) => {
    const actId = act && act.split(':')[0].concat(':::::')
    dispatch({
      type: SET_LEGISLATION_ACT,
      act: actId
    })
    dispatch(setLegislationPath(act))
  }
}

const setLegislationActHoverIconMap = (actNodes: Record<string, LegislationActNode>) => {
  return (dispatch:AppDispatch, _:any) => {
    const actHoverIconList = Object.entries(actNodes)
      .filter(([_, node]) => node.hoverIcon)

    const actHoverIconMap = new Map(actHoverIconList)

    dispatch({
      type: SET_LEGISLATION_ACT_HOVER_ICON_MAP,
      actHoverIconMap
    })
  }
}

export const setLegislationActNodes = (actNodes: Record<string, LegislationActNode>) => {
  return (dispatch: AppDispatch, _:any) => {
    dispatch(setLegislationActHoverIconMap(actNodes) as any)

    dispatch({
      type: SET_LEGISLATION_ACT_NODES,
      actNodes
    })
  }
}

const setLegislationActIdMapFromFolders = (folders: LegislationFolder[]) => {
  const actIdMap = new Map()

  for (let i = 0; i < folders.length; i++) {
    const categories = folders[i].categories
    for (let j = 0; j < categories.length; j++) {
      const legislation = categories[j].legislation
      for (let k = 0; k < legislation.length; k++) {
        const { id, number, title, actNote, category, folder, level, levelName, archive, hidden, isComplete } = legislation[k]
        actIdMap.set(id, { number, title, actNote, folderName: folder, category, level, levelName, archive, hidden, isComplete })
      }
    }
  }

  const acts = Array.from(actIdMap).map(([id, values]) => ({ id, ...values })) // TODO check if valid for IE
  const sortedActs = sortBy(acts, ({ title }) => title)

  return (dispatch:AppDispatch, _:any) => {
    dispatch({
      type: SET_LEGISLATION_ACT_ID_MAP,
      actIdMap
    })
    dispatch(setLegislationActs(sortedActs))
  }
}

const setLegislationActs = (acts: LegislationAct[]) => ({
  type: SET_LEGISLATION_ACTS,
  acts
})

const setLegislationFoldersMap = (folders: LegislationFolder[]) => {
  const foldersMap = folders && folders.length && new Map(folders.map(folder => [folder.name, folder.categories]))

  return (dispatch:AppDispatch, _:any) => {
    dispatch({
      type: SET_LEGISLATION_FOLDERS_MAP,
      foldersMap
    })
  }
}

export const setLegislationFolders = (folders: LegislationFolder[]) => {
  return (dispatch: AppDispatch, _:any) => {
    dispatch(setLegislationActIdMapFromFolders(folders) as any)
    dispatch(setLegislationFoldersMap(folders) as any)
    dispatch({
      type: SET_LEGISLATION_FOLDERS,
      folders
    })
  }
}

export const setLegislationWrapperEditMode = (editMode: boolean) => ({
  type: SET_LEGISLATION_WRAPPER_EDIT_MODE,
  editMode
})

export const setLegislationWrapperAdminButton = (AdminButton:JSXElementConstructor<AdminButtonProps>) => ({
  type: SET_LEGISLATION_WRAPPER_ADMIN_BUTTON,
  AdminButton
})

export const setLegislationWrapperContentEditor = (ContentEditor: JSXElementConstructor<any>) => ({
  type: SET_LEGISLATION_WRAPPER_CONTENT_EDITOR,
  ContentEditor
})

export const setLegislationWrapperTitleEditor = (TitleEditor: JSXElementConstructor<TitleEditorProps>) => ({
  type: SET_LEGISLATION_WRAPPER_TITLE_EDITOR,
  TitleEditor
})
